<template>
    <v-card>
        <v-card-text>
            <v-form data-cy="products-open-close-room-form">
                <v-row>
                    <v-col cols="12" md="4">
                        <date-range-m-extended
                            :popover="{placement: 'bottom'}"
                            :show-icon="false"
                            :single-line="false"
                            :_start="model.dateFrom"
                            :_end="model.dateTo"
                            @change-start="model.dateFrom = $event"
                            @change-end="model.dateTo = $event"
                        />
                    </v-col>
                    <v-col cols="12" md="8">
                        <div class="d-flex align-center">
                            <days-picker v-model="model.dayOfWeek" />
                            <v-select
                                v-model="model.tariffId"
                                class="ms-4"
                                clearable
                                hide-details
                                :label="$t('tariff')"
                                :items="tariffs"
                                item-title="name"
                                max-width="240"
                                item-value="id"
                            />
                        </div>
                    </v-col>
                </v-row>
                <v-row v-if="model.services.length" class="mt-3">
                    <v-col cols="12" md="12">
                        <h3>
                            {{ $t('supplier.open_close_rooms_title') }}
                        </h3>
                        <div class="d-flex flex-column">
                            <v-checkbox
                                v-for="(service, index) in services"
                                :key="service.id"
                                v-model="model.services[index].checked"
                                :label="service.name"
                                hide-details
                            />
                        </div>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="12">
                        <v-btn color="primary" class="mr-4" :disabled="!valid()" @click="clickUpdate">
                            {{ $t('supplier.open') }}
                        </v-btn>
                        <v-btn color="primary" :disabled="!valid()" @click="clickClose">
                            {{ $t('supplier.close') }}
                        </v-btn>
                    </v-col>
                </v-row>
            </v-form>
        </v-card-text>
    </v-card>
</template>

<script lang="ts">
    import {Component, mixins, Prop} from 'vue-facing-decorator'
    import DateRangeMExtended from '@/components/supplier/DateRangeMExtended.vue'
    import {FormValidationRulesMixin} from '@/mixins/FormValidationRulesMixin.vue'
    import DaysPicker from '@/components/supplier/DaysPicker.vue'

    @Component({
        components: {DaysPicker, DateRangeMExtended},
    })
    export class OpenCloseRooms extends mixins(FormValidationRulesMixin) {
        @Prop() startDate
        @Prop() endDate
        @Prop() services
        @Prop() tariffs

        model = {
            dateFrom: null,
            dateTo: null,
            dayOfWeek: [true, true, true, true, true, true, true],
            services: [],
            operation: null,
            tariffId: null,
        }

        mounted() {
            this.model.dateFrom = this.startDate
            this.model.dateTo = this.endDate

            let services = []
            this.services.forEach(service => {
                services.push({
                    serviceId: service.id,
                    categoryId: service.categoryId,
                    checked: false,
                })
            })
            this.model.services = services
        }

        valid() {
            const filtered = this.model.services.filter(service => {
                return service.checked === false
            })

            return filtered.length !== this.model.services.length
        }

        clickClose() {
            this.model.operation = 'BLOCK'
            this.$emit('update', this.model)
        }

        clickUpdate() {
            this.model.operation = 'CLEAR_BLOCK'
            this.$emit('update', this.model)
        }
    }

    export default OpenCloseRooms
</script>

<style scoped lang="scss"></style>
